<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title 
        icon="fa fa-file-alt"
        main="Relatórios"
        sub="Liberação Comercial"
      ></page-title>

      <!-- Filters -->
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-sm-12 mb-3">
            <base-input 
              type="date" 
              id="example-date-input"
              label="Data de Início"
              v-model="filter.start_date"
            />
          </div>

          <div class="col-md-4 col-sm-12 mb-3">
            <base-input 
              type="date" 
              id="example-date-input"
              label="Data de Fim"
              v-model="filter.end_date"
            />
          </div>

          <div class="col-md-4 col-sm-12 mb-3">
            <label class="form-control-label">Autor</label>
            <multiselect
              v-model="filter.author"
              :options="users"
              label="name"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              placeholder="AUTOR"
            />
          </div>

          <div class="col-md-4 col-sm-12 mb-3">
            <label class="form-control-label">Vendedor</label>
            <multiselect
              v-model="filter.salesman"
              :options="salesmans"
              label="name"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              placeholder="VENDEDOR"
            />
          </div>

          <div class="col-md-4 col-sm-12 mb-3">
            <label class="form-control-label">Cliente</label>
            <multiselect
              v-model="filter.client"
              :options="clients"
              label="razao_social"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              placeholder="VENDEDOR"
              @search-change="initClients"
            />
          </div>

          <div class="col-md-4 col-sm-12 mt-5">
            <base-switch 
            v-model="filter.approved"
            label="Aprovadas" />
          </div>
        </div>

        <div slot="footer" class="row justify-content-end mr-1">
          <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
          <base-button type="secondary" class="mr-2 mt-2" @click="generatePDF" >Gerar PDF</base-button>
          <base-button type="secondary" class="mt-2" @click="exportToExcel" >Gerar Excel</base-button>
          <base-button type="primary" class="ml-2 mt-2" @click="generateReport" v-loading="isLoading">Gerar Relatório</base-button>
        </div>
      </card>
    </div>

    <card  v-show="commercial_releases.length" ref="report" v-loading="isLoading">
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          Liberação Comercial - {{ lastEdition | formatDate("full") }}
        </h6>
      </div>

      <div class="col print-only">
        <img
          :src="
            setting_image.logo_sgv && setting_image.logo_sgv.value ?
            setting_image.logo_sgv.value : '/img/brand/top-logo.png'
          "
          class="navbar-brand-img"
          style="
            width: 200px;
            display: block;
            margin-left: auto;
            margin-right: auto;
          "
        />
        <h5 class="h1 mb-0">Relatório</h5>
        <h6 class="h3 text-uppercase text-muted ls-1 mb-1">
          Liberação Comercial - {{ lastEdition | formatDate("full") }}
        </h6>
        <br />
        <br />
        <br />
      </div>
      <el-table
        class="table-responsive table-striped clickable-rows"
        header-row-class-name="thead-light"
        :data="commercial_releases"
        ref="commercial_releases"
      >
        <el-table-column label="Status" prop="status" width="100px" v-slot="{ row }" sortable>
          <badge class="badge-dot mr-4" type v-if="row.status == 'approved'">
            <i class="bg-success"></i> Aprovado
          </badge>
          <badge class="badge-dot mr-4" type v-if="row.status == 'pendent'">
              <i class="bg-warning"></i>Pendente
            </badge>
          <badge class="badge-dot mr-4" type v-if="row.status == 'disapprove'">
            <i class="bg-danger"></i> Reprovado
          </badge>
        </el-table-column>
        <el-table-column label="Data de criação" v-slot="{ row }" sortable>
          {{ row.created_at | humanDate }}
        </el-table-column>
        <el-table-column
          label="Cliente"
          prop="client.razao_social"
          sortable
        />
        <el-table-column label="Vendedor" prop="salesman.name" sortable />
        <el-table-column label="Autor" prop="author.name" sortable />
        <el-table-column label="Valor Total" v-slot="{ row }" sortable>
          <span>{{
            row.value.toLocaleString("pt-BR", {
              style: "currency",
              currency: "brl",
            })
          }}</span>
        </el-table-column>
        <el-table-column label="Ações" width="120" v-slot="{ row }">
          <el-tooltip
            content="Visualizar Descontos"
            placement="top"
          >
            <a @click="rowClicked(row, true)">
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fa fa-eye mt-2"></i>
              </span>
            </a>
          </el-tooltip>
      </el-table-column>
        <el-table-column :min-width="1" type="expand" v-slot="{ row }" >
          <template align="right">
            <div>
              <div class="card-deck">
                <card>
                  <h5 class="card-title"> Descrição </h5>
                  <div v-if="rowExpanded" class="tags-input__wrapper">
                    {{ row.description }}
                  </div>
                </card>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <br />
      <br />
      <div class="card-footer py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="changePage"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        >
        </base-pagination>
      </div>
    </card>
  </div>
</template>

<script>


const CHART_COLORS = [
  "#11cdef",
  "#5603ad",
  "#f5365c",
  "#8965e0",
  "#ffd600",
  "#2bffc6",
  "#fb6340",
  "#f3a4b5",
  "#5e72e4",
  "#2dce89",
];

import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import { DatePicker } from "element-ui";
import LineChart from "@/components/Charts/LineChart";
import PageTitle from "@/layouts/PageTitle";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Select,
  Option,
  Tag,
} from "element-ui";

export default {
  components: {
    Multiselect,
    LineChart,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
    [DatePicker.name]: DatePicker,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    PageTitle,
  },
  data() {
    return {
      isLoading: false,
      isLoadingSalesman: false,
      paginated_data: [],
      purchase_orders: [], 
      salesmans: [],
      users: [],
      filter: {
        start_date: '',
        end_date: '',
        salesman: {},
        client: {},
        author: {},
        approved: true 
      },
      clients: [],
      reports_campaigns: [],
      campaigns: [],
      commercial_releases: [],
      campaign_params:[],
      lastEdition: new Date(),
    };
  },
  computed: {
    setting_image() {
      return this.$store.state.imageSettings || {}
    }
  },
  mounted() {
    this.initUsers();
    this.initSalesmen();
    this.initClients();
  },
  methods: {
    generatePDF() {
      window.print();
    },
    exportToExcel() {
      return this.$exportToExcel();
    },
    clearFilters() {
      this.filter.start_date = "",
      this.filter.end_date = "",
      this.filter.author = {},
      this.filter.salesman = {},
      this.filter.client = {}
    },
    sortObject(obj) {
      return Object.keys(obj).sort().reduce(function (result, key) {
          result[key] = obj[key];
          return result;
      }, {})
    },
    rowClicked(row, ok) {
      // Se o botão de detalhes for clicado, expandir linha
      if (ok === true) {
        if (this.rowExpanded === row) {
          this.$refs.commercial_releases.toggleRowExpansion(row, false);
          this.rowExpanded = null;
          return;
        }
        if (this.rowExpanded !== null) {
          this.$refs.commercial_releases.toggleRowExpansion(this.rowExpanded, false);
        }

        this.$refs.commercial_releases.toggleRowExpansion(row, true);
        this.rowExpanded = row;
      }
    },
    async getComercialReleases(q, page) {
      let data = { page: page, q: { status: "approved" }, list_commercial_releases: true };

      this.filter.approved ? data.q["status"] = "approved" : data.q["status"] = "disapprove" 
      if (this.filter.salesman && this.filter.salesman.id)
        data.q["salesman_id"] = this.filter.salesman.id;
      if (this.filter.client && this.filter.client)
        data.q["client_id"] = this.filter.client.id;
      if (this.filter.author && this.filter.author.id)
        data.q["author_id"] = this.filter.author.id;

      data.start_date =  this.filter.created_at || null
      data.end_date = this.filter.end_date || null

      const response = await this.$http.secured.get("/api/v1/commercial_releases", { params: data })
        try {
          console.log(response)
          this.paginated_data = response.data;
          this.commercial_releases = this.paginated_data["commercial_releases"];
          console.log(this.commercial_releases)
        }
        catch(error) { this.setError(error, "Something went wrong") }
      console.log("getComercialReleases2")
      this.isLoading = false
    },
    initClients(query) {
      var queryObj = null;
      if (typeof query != "undefined" && query != "") {
        queryObj = {
          razao_social: query,
        };
      }
      this.$http.secured
        .get("/api/v1/clients", {
          params: {
            q: queryObj,
          },
        })
        .then((response) => {
          this.clients = response.data["clients"]
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    initUsers(q = '') {
      let data = { q: { status: true } }
      this.$http.secured.get("/api/v1/users", { params: data })
      .then((response) => {
        console.log(response)
        this.users = response.data.users;
      });
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    changePage(page) {
      let filterInput = null;
      if (this.filtered) filterInput = this.filter;
      this.generateReport(filterInput, page);
    },
    initSalesmen(query) {
      var data = {
        name_only: true,
        q: { name: query, is_salesman: true, status: this.active },
      };

      this.isLoadingSalesman = true;
      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.isLoadingSalesmans = false;
          this.salesmans = response.data || [];
        })
        .catch(() => (this.isLoadingSalesman = true));
    },
    initCampaign(){
     this.$http.secured
      .get("/api/v1/campaigns",{
        params: {
          unpaged: true,
          active: true,
        }
      })
      .then(response => {
        this.campaigns = response.data;
      })
      .catch(error => this.setError(error, "failed to fetch campaigns"));
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Soma";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values
            .reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
            .toLocaleString("pt-BR", { style: "currency", currency: "brl" });
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    generateReport(q, page) {
      if (this.filter.start_date > this.filter.end_date) {
        this.$toasted.global.defaultWarnig({msg: "Data de início não pode ser maior que a data final"});
      return;
      }
      this.isLoading = true
      this.getComercialReleases(q, page)
    },
  },
};
</script>
<style >
.el-table__fixed,
.el-table__fixed-right {
  background-color: white;
  text-align: center;
}
.el-table__footer {
  font-weight: bold;
  width: 200px;
}
.el-table--scrollable-x .el-table__body-wrapper {
  overflow-x: overlay;
}
</style>
